import { Button } from '@/components/ui/button';
import { Link, createFileRoute, redirect } from '@tanstack/react-router';
import { ArrowLeft, Upload } from 'lucide-react';

export const Route = createFileRoute('/settings/import')({
  beforeLoad: () => {
    throw redirect({ to: '/settings', search: { tab: 'import' } });
  },
});

export function ImportPage() {
  return (
    <div className="flex flex-col items-center justify-center h-[calc(100vh-7rem)] px-6">
      <div className="flex flex-col items-center text-center max-w-sm">
        <div className="rounded-2xl bg-muted p-5 mb-6">
          <Upload className="h-10 w-10 text-muted-foreground" />
        </div>
        <h1 className="text-xl font-semibold tracking-tight text-foreground mb-2">Import</h1>
        <p className="text-sm text-muted-foreground mb-8">
          Data import from external sources is coming soon.
        </p>
        <Link to="/settings">
          <Button variant="outline" size="sm">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Settings
          </Button>
        </Link>
      </div>
    </div>
  );
}
